/* Luméa UI v4 — substituir assets/lumea-ui.js
   Cobre Prompts 3, 4, 5, 6.
   Som único (window.__lumeaSoundOwner), shimmer real on-demand no ATC e checkout. */
(function () {
  if (window.__lumeaUIv4) return;
  window.__lumeaUIv4 = true;
  window.__lumeaSoundOwner = 'v4'; // marca de propriedade — qualquer Audio() antigo deve ser removido

  // ---------- SOM (único) ----------
  let _ctx = null;
  function playShimmerSound() {
    try {
      if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
      if (_ctx.state === 'suspended') _ctx.resume();
      const t0 = _ctx.currentTime;
      const o = _ctx.createOscillator();
      const g = _ctx.createGain();
      o.type = 'sine';
      o.frequency.setValueAtTime(880, t0);
      o.frequency.exponentialRampToValueAtTime(1760, t0 + 0.18);
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(0.04, t0 + 0.04);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.45);
      o.connect(g).connect(_ctx.destination);
      o.start(t0); o.stop(t0 + 0.5);
    } catch (e) { /* silent */ }
  }

  // ---------- SHIMMER helper ----------
  function shimmerOnce(el, duration = 1200) {
    if (!el) return;
    el.classList.remove('shimmer-active');
    void el.offsetWidth;
    el.classList.add('shimmer-active');
    setTimeout(() => el.classList.remove('shimmer-active'), duration);
  }

  // ---------- ATC: hover (desktop) + sucesso (todos) ----------
  const isMobile = matchMedia('(hover: none)').matches;

  function bindAtcButton(btn) {
    if (!btn || btn.__lumeaBound) return;
    btn.__lumeaBound = true;
    btn.classList.add('lumea-atc');
    if (!isMobile) {
      btn.addEventListener('mouseenter', () => {
        shimmerOnce(btn, 900);
        playShimmerSound();
      });
    }
  }
  function scanAtcButtons(root = document) {
    root.querySelectorAll('.product-form__submit, button[name="add"]').forEach(bindAtcButton);
  }
  scanAtcButtons();
  new MutationObserver(muts => muts.forEach(m => m.addedNodes.forEach(n => {
    if (n.nodeType === 1) scanAtcButtons(n);
  }))).observe(document.body, { childList: true, subtree: true });

  // Intercept cart/add success → shimmer + sound + refresh free shipping bar
  const _origFetch = window.fetch;
  window.fetch = function (...args) {
    const p = _origFetch.apply(this, args);
    try {
      const url = (args[0] && (args[0].url || args[0])) + '';
      if (/\/cart\/add(\.js|$)/.test(url)) {
        p.then(r => {
          if (r && r.ok) {
            const btn = document.activeElement && document.activeElement.matches('button')
              ? document.activeElement
              : document.querySelector('.product-form__submit');
            shimmerOnce(btn, 900);
            playShimmerSound();
            refreshFreeShippingBar();
          }
        }).catch(() => {});
      }
      if (/\/cart(\/(update|change|clear))?(\.js|$)/.test(url)) {
        p.then(() => refreshFreeShippingBar()).catch(() => {});
      }
    } catch (e) {}
    return p;
  };

  // Eventos do tema Dawn
  document.addEventListener('cart:updated', refreshFreeShippingBar);
  document.addEventListener('cart:refresh', refreshFreeShippingBar);

  // ---------- FREE SHIPPING BAR (real-time) ----------
  function refreshFreeShippingBar() {
    const bar = document.querySelector('.lumea-fs-bar');
    if (!bar) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        const threshold = parseInt(bar.dataset.threshold || '4000', 10); // cêntimos
        const total = cart.total_price || 0;
        const remaining = Math.max(0, threshold - total);
        const textEl = bar.querySelector('.lumea-fs-bar__text');
        if (!textEl) return;
        if (remaining === 0) {
          textEl.textContent = 'Tens envio grátis!';
        } else {
          const fmt = (cart.currency || 'EUR');
          const value = (remaining / 100).toFixed(2).replace('.', ',') + ' ' +
                        (fmt === 'EUR' ? '€' : fmt);
          textEl.textContent = 'Faltam ' + value + ' para envio grátis';
        }
      }).catch(() => {});
  }
  refreshFreeShippingBar();

  // Cart icon na barra → abre cart drawer
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.lumea-fs-bar__cart');
    if (!btn) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      // fallback: clica no link/ícone do carrinho do header
      const headerCart = document.querySelector('#cart-icon-bubble, a[href="/cart"]');
      if (headerCart) headerCart.click();
    }
  });

  // ---------- CHECKOUT BUTTON shimmer (Prompt 6) ----------
  function getCheckoutBtn() {
    return document.querySelector('#CartDrawer-Checkout, .cart__checkout-button, cart-drawer button[name="checkout"]');
  }
  function shimmerCheckoutOnOpen() {
    const btn = getCheckoutBtn();
    if (!btn) return;
    shimmerOnce(btn, 1500);
  }
  // Hover (desktop)
  document.addEventListener('mouseenter', (e) => {
    if (!isMobile && e.target.matches && e.target.matches('#CartDrawer-Checkout, .cart__checkout-button')) {
      shimmerOnce(e.target, 900);
    }
  }, true);
  // Open drawer detection — observa atributo `open` ou classe `active`
  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    new MutationObserver(() => {
      if (drawerEl.classList.contains('active') || drawerEl.hasAttribute('open')) {
        shimmerCheckoutOnOpen();
      }
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class', 'open'] });
  }
})();
